module.exports = __webpack_public_path__ + "images/billboard3-d31d8a95d44eb241514c3cbb40533976.jpg";